import React from "react";

export const Image = ({ title, smallImage }) => {
  return (
    <div className="gallery-item">
      <div className="hover-bg">
        {" "}
        <a  title={title} data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img 
            src={smallImage} 
            className="img-responsive" 
            alt={title} 
            loading="lazy"
          />{" "}
        </a>{" "}
      </div>
    </div>
  );
};
